import * as yup from "yup";
import YupPassword from "yup-password";
import i18n from "../../../../i18n";
import containsConsecutives from "../../../../utils/containsConsecutives";

YupPassword(yup);

yup.addMethod(yup.string, "containsConsecutives", function(errorMessage, len) {
    return this.test(`sequential-numbers-and-letters`, errorMessage, function(value) {
        const {path, createError} = this;
        return containsConsecutives(value, len) ? createError({path, message: errorMessage}) : true;
    });
});
const requiredMessage = () => i18n.t("validation.required", {ns: "common"});

const companyShape = yup.object().shape({
    company: yup.string().required(requiredMessage),
    subCompanies: yup
        .array()
        .of(yup.string())
        .required(requiredMessage)
        .min(1, "En az bir şube seçmelisiniz")
});

export const poolFormValidation = yup.object().shape({
    name: yup.string().required(requiredMessage),
    city: yup.string().required(requiredMessage),
    managerCompany: yup
        .string()
        .oneOf(["vigo", "agency"], requiredMessage)
        .required(requiredMessage),
    companies: yup.array().of(yup.string()),
    subCompanies: yup.array().of(yup.string()),
    companyInfoArray: yup
        .array()
        .of(companyShape)
        .required(requiredMessage)
        .min(1, "En az bir şirket eklemelisiniz")
        .test("has-valid-companies", "Tüm şirketler için en az bir şube seçmelisiniz", function(
            value
        ) {
            if (!value || value.length === 0) return false;
            // En az bir company'de subCompanies dolu olmalı
            const hasValidCompany = value.some(
                companyInfo => companyInfo.subCompanies && companyInfo.subCompanies.length > 0
            );
            return hasValidCompany;
        })
});
